import { CollectionCard } from "../components/CollectionCard";
import { EmptyState } from "../components/EmptyState";
import { Seo } from "../components/Seo";
import { collections } from "../data/collections";

export function CollectionsPage() {
  return (
    <main id="main" className="page">
      <Seo
        title="Collections"
        description="Rings, necklaces, earrings and bracelets. A collection is on its way."
        path="/collections"
      />
      <p className="kicker">Coming soon</p>
      <h1>Collections</h1>
      <p className="lede">
        A collection of rings, necklaces, earrings and bracelets is on its way.
      </p>
      {collections.length === 0 ? (
        <EmptyState title="Collections">
          A collection is on its way.
        </EmptyState>
      ) : (
        <div className="collection-rail section">
          {collections.map((collection) => (
            <CollectionCard key={collection.slug} collection={collection} />
          ))}
        </div>
      )}
    </main>
  );
}
